import React from 'react';
import { XIcon } from 'lucide-react';
import { painPoints } from '../data/content';
import { SectionHeading } from './SectionHeading';
export function PainPoints() {
  return <section className="bg-cream-50 px-5 py-12 sm:py-20" data-id="element-187" data-mp="26yfq3dt2d3kj">
      <div className="mx-auto max-w-6xl" data-id="element-188" data-mp="26xwjgt8v61lt">
        <SectionHeading eyebrow="¿Te pasa esto?" title="Si tu perro sufre cuando te vas, esto te va a sonar conocido" data-id="element-189" data-mp="2bxiucw17z5rg" />

        <ul className="mt-7 grid grid-cols-2 gap-2.5 sm:mt-12 sm:gap-x-10 sm:gap-y-7" data-id="element-190" data-mp="1xwyarxnhd5ww">
          {painPoints.map(point => <li key={point.title} className="rounded-xl bg-cream-100 p-3 ring-1 ring-inset ring-forest-900/[0.06] transition-colors duration-150 ease-out hover:bg-cream-200/60 sm:flex sm:gap-3.5 sm:rounded-none sm:border-b sm:border-forest-900/10 sm:bg-transparent sm:p-0 sm:pb-6 sm:ring-0 sm:hover:bg-transparent" data-id="element-191" data-mp="21x8ltoq4qmim">
              <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-clay/10 sm:mt-0.5 sm:h-6 sm:w-6" data-id="element-192" data-mp="3nbmn5yw2mnux">
                <XIcon className="h-3 w-3 text-clay sm:h-3.5 sm:w-3.5" aria-hidden="true" data-id="element-193" data-mp="1yykdteanra18" />
              </span>
              <div className="mt-2 sm:mt-0" data-id="element-194" data-mp="1tzra2dl6axe9">
                <h3 className="text-[0.8rem] font-semibold leading-snug text-forest-900 sm:text-base" data-id="element-195" data-mp="27rxex3ivlhye">
                  {point.title}
                </h3>
                <p className="mt-1 text-[0.72rem] leading-snug text-forest-900/60 sm:text-sm sm:leading-relaxed" data-id="element-196" data-mp="23trf6fggg2mz">
                  {point.text}
                </p>
              </div>
            </li>)}
        </ul>

        <p className="mx-auto mt-7 max-w-2xl text-center font-display text-lg leading-snug text-forest-800 sm:mt-12 sm:text-[1.75rem]" style={{
        fontWeight: 600
      }} data-id="element-197" data-mp="1p30lt2z7svhr">
          ¿Cuántas semanas más vas a volver a casa con miedo a lo que vas a encontrar?
        </p>
      </div>
    </section>;
}